import { SearchFilters, SearchUseCase } from "@outschool/gql-backend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import _Random from "lodash/random";

import searchListingsQuery from "../../Search/graphql/searchListingsQuery";
import {
  SearchListingsQuery,
  SearchListingsQueryVariables,
} from "@outschool/gql-frontend-generated";

type useParentsAlsoLikeListParams = {
  searchFilters: SearchFilters;
  limit?: number;
  pageLocation: string;
};
export const useParentsAlsoLikeList = ({
  searchFilters,
  limit,
  pageLocation,
}: useParentsAlsoLikeListParams) => {
  const { data } = useQueryWithPreviousData<
    SearchListingsQuery,
    SearchListingsQueryVariables
  >(searchListingsQuery, {
    variables: {
      searchFilters: {
        ...searchFilters,
        isAvailable: true,
      },
      skipRating: false,
      withRecentReviews: false,
      includeMatchingSections: true,
      limit: limit || null,
      useCase: SearchUseCase.RelatedContent,
      pageLocation,
    },
    context: { doNotRetry: true },
  });

  return {
    listings: data?.searchListings?.listings,
    searchUid: data?.searchListings?.searchUid,
  };
};
